import { LiveKitRoom } from "@livekit/components-react";
import { toast } from "sonner";
import { Tabs, TabsContent, TabsList, TabsTrigger } from "../ui/tabs";
import { ChatPanel } from "./ChatPanel";
import { PeoplePanel } from "./PeoplePanel";
import { TracksPanel } from "./TracksPanel";
import { LiveStage, OfflineStage } from "./LiveStage";

const deviceError = (f) => (f === "PermissionDenied"
  ? "Your browser blocked the camera or mic. Allow access in the address bar and rejoin."
  : "Couldn't open your camera or mic.");

export const Stage = ({ lk, lkError, engine, inst, canPlay, state, setLocalMic }) => {
  if (!lk) return <OfflineStage reason={lkError || "Connecting live video…"} canPublish={canPlay} onLocalMic={setLocalMic} />;
  return (
    <LiveKitRoom key={lk.token} serverUrl={lk.server_url} token={lk.token} connect audio={lk.can_publish} video={lk.can_publish}
      onError={(e) => toast.error(e?.message || "Live video error")} onMediaDeviceFailure={(f) => toast.error(deviceError(f))}>
      <LiveStage engine={engine} inst={canPlay ? inst : null} stageIds={state.stage} kind={state.kind}
        canPublish={lk.can_publish} onLocalMic={setLocalMic} />
    </LiveKitRoom>
  );
};

export const SpaceSidebar = ({ spaceId, state, messages, setMessages, refresh, mix, onAssign, onTracks }) => (
  <aside className="panel p-4 h-fit">
    <Tabs defaultValue="chat">
      <TabsList className="w-full bg-black">
        <TabsTrigger value="chat" className="flex-1" data-testid="side-tab-chat">Chat</TabsTrigger>
        <TabsTrigger value="people" className="flex-1" data-testid="side-tab-people">Who's here · {state.people.length}</TabsTrigger>
        <TabsTrigger value="tracks" className="flex-1" data-testid="side-tab-tracks">Tracks</TabsTrigger>
      </TabsList>
      <TabsContent value="chat" className="mt-4">
        <ChatPanel spaceId={spaceId} messages={messages} setMessages={setMessages} meId={state.me.user_id} />
      </TabsContent>
      <TabsContent value="people" className="mt-4"><PeoplePanel state={state} refresh={refresh} /></TabsContent>
      <TabsContent value="tracks" forceMount className="mt-4 data-[state=inactive]:hidden">
        <TracksPanel spaceId={spaceId} canControl={state.me.can_control} playback={state.playback} mixer={mix} onAssign={onAssign} onTracks={onTracks} />
      </TabsContent>
    </Tabs>
  </aside>
);
